document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.getElementById('FloatingSidebar');

  if (!sidebar) return;

  const EXCLUDED_IDS = [
    'breadcrumbs',
    'hero_image_text',
    'you_may_also_like',
    'workout_tips',
    'FloatingSidebar'
  ];

  const COLUMN_SPACING = 100;
  const WRAPPER_PADDING = 20;
  const BOTTOM_OFFSET = 112;

  const Z_INDEX = 50;

  const main = document.querySelector('main');
  const firstLevelChildren = Array.from(main.children);

  const filteredChildren = firstLevelChildren.filter((el) => {
    const id = el.id || "";
    return !EXCLUDED_IDS.some(ex => id.includes(ex));
  });

  const imageBannerWrappers = Array.from(document.querySelectorAll('div[data-id*="image-banner-wrapper"]:not(#FloatingSidebar div)'))
    .filter(el => !el.closest('section[id*="page_hero_banner"]'));

  const concludingSection = document.getElementById('conclusion');

  let currentBannerHeight = 0;

  const getWrappers = () => filteredChildren.flatMap(el =>
    Array.from(el.querySelectorAll('.wrapper'))
  );

  const getSidebarOffset = () => parseFloat(getComputedStyle(sidebar).getPropertyValue('--sidebar-offset')) || 0;

  const isMobile = () => window.innerWidth < 768;

  const getSidebarPaddingRight = (wrapper) => {
    const style = window.getComputedStyle(wrapper);
    return parseFloat(style.marginRight) || 0;
  };

  const getMaxSidebarBottom = () => concludingSection ? concludingSection.offsetTop + concludingSection.offsetHeight - BOTTOM_OFFSET : 0;

  const waitForHeroVideoWrapper = (callback) => {
    const wrapper = document.getElementById('video-hero-wrapper');
    if (wrapper) return callback(wrapper);

    const interval = setInterval(() => {
      const wrapper = document.getElementById('video-hero-wrapper');
      if (wrapper) {
        clearInterval(interval);
        callback(wrapper);
      }
    }, 100);

    setTimeout(() => clearInterval(interval), 5000);
  };

  const updateHeroVideoWidth = (heroVideoWrapper) => {
    if (isMobile()) {
      sidebar.style.display = 'none';
      return;
    }

    const wrappers = getWrappers();

    if (!wrappers.length) return;

    const heroVideoWidth = wrappers[0].getBoundingClientRect().width - sidebar.offsetWidth - COLUMN_SPACING - WRAPPER_PADDING;
    const marginRight = getSidebarPaddingRight(wrappers[0]);

    heroVideoWrapper.style.width = `${heroVideoWidth}px`;
    heroVideoWrapper.style.marginRight = `${sidebar.offsetWidth + marginRight + COLUMN_SPACING}px`;
  };

  const updateWrappersPadding = () => {
    if (isMobile()) {
      sidebar.style.display = 'none';
      return;
    }

    const wrappers = getWrappers();
    const paddingValue = sidebar.offsetWidth + COLUMN_SPACING;

    imageBannerWrappers.forEach(wrapper => {
      wrapper.style.paddingRight = `${paddingValue}px`;
    });

    wrappers.forEach(wrapper => {
      wrapper.style.paddingRight = `${paddingValue}px`;
    });
  };

  const updateSidebarPosition = () => {
    if (isMobile()) {
      sidebar.style.display = 'none';
      return;
    }

    const scrollY = window.scrollY;
    const offset = getSidebarOffset();
    const header = document.querySelector('header');
    const breadcrumbsSection = document.querySelector('[id*="breadcrumbs"]');
    const heroImageTextSection = document.querySelector('div[id*="hero_image_text"]');

    const topOffset =
      (currentBannerHeight) +
      (breadcrumbsSection ? breadcrumbsSection.offsetHeight : 0) +
      (heroImageTextSection ? heroImageTextSection.offsetHeight : 0) + offset;

    const maxBottom = getMaxSidebarBottom();
    const sidebarBottomY = scrollY + sidebar.offsetHeight - currentBannerHeight;

    sidebar.style.right = `${getWrappers()[0] ? getSidebarPaddingRight(getWrappers()[0]) : 0}px`;

    if (sidebarBottomY >= maxBottom) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = `${maxBottom - sidebar.offsetHeight}px`;
      sidebar.style.zIndex = 0;
    } else if (scrollY < topOffset) {
      sidebar.style.position = 'absolute';
      sidebar.style.top = `${topOffset}px`;
      sidebar.style.zIndex = Z_INDEX;
    } else {
      sidebar.style.position = 'fixed';
      sidebar.style.top = `${(header ? header.offsetHeight : 0)}px`;
      sidebar.style.zIndex = Z_INDEX;
    }
  };

  const resetHeroVideoStyles = (heroVideoWrapper) => {
    if (!heroVideoWrapper) return;
    heroVideoWrapper.style.width = '';
    heroVideoWrapper.style.marginRight = '';
  };

  const resetWrappersPadding = () => {
    const wrappers = getWrappers();

    wrappers.forEach(wrapper => {
      wrapper.style.paddingRight = '';
    });

    imageBannerWrappers.forEach(wrapper => {
      wrapper.style.paddingRight = '';
    });
  };

  const vueApp = document.querySelector('#vue-app') || main;
  const observer = new MutationObserver(() => {
    updateWrappersPadding();
    waitForHeroVideoWrapper(updateHeroVideoWidth);
  });
  observer.observe(vueApp, { childList: true, subtree: true });

  const sidebarRO = new ResizeObserver(() => {
    requestAnimationFrame(() => {
      updateSidebarPosition();
      updateWrappersPadding();
      waitForHeroVideoWrapper(updateHeroVideoWidth);
    });
  });
  sidebarRO.observe(sidebar);

  window.addEventListener('scroll', () => requestAnimationFrame(() => updateSidebarPosition()));
  window.addEventListener('resize', () => {
    if (isMobile()) {
      resetWrappersPadding();
      waitForHeroVideoWrapper(resetHeroVideoStyles);
    }

    updateSidebarPosition();
    updateWrappersPadding();
    waitForHeroVideoWrapper(updateHeroVideoWidth);
  });

  const waitForBanner = (callback) => {
    const interval = setInterval(() => {
      const banner = document.querySelector('iframe[title^="_jst-iframe"]');
      if (banner) {
        clearInterval(interval);
        currentBannerHeight = banner.offsetHeight;
        callback(banner);
      }
    }, 100);

    setTimeout(() => clearInterval(interval), 5000);
  };

  waitForBanner((banner) => {
    const ro = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        currentBannerHeight = banner.offsetHeight;
        updateSidebarPosition();
      });
    });
    ro.observe(banner);
    updateSidebarPosition();
  });
});
